import axios from "axios";
import Config from "../utilities/Config";
const BASE_URL = `${Config.baseUrl}api/admin`;

class ProfileSettingRequests {
  getHeaders() {
    return {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("txtconnect_ng_admin_token")}`,
    };
  }

  async updateProfile(payload) {
    try {
      const response = await axios.post(`${BASE_URL}/update/profile`, payload, {
        headers: this.getHeaders(),
      });
      return {
        success: true,
        message: "Profile updated successfully",
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        message: error.response.data.reason || "An error occurred",
        data: null,
      };
    }
  }

  async updatePassword(payload){
    try{
      const response = await axios.post(`${BASE_URL}/change/password`, payload, {
        headers: this.getHeaders(),
      });
      return {
        success: true,
        message: "Password updated successfully",
        data: response.data,
      };
    }catch(error){
      return {
        success: false,
        message: error.response.data.reason || "An error occurred",
        data: null,
      };
    }
  }
}
const profileSettingRequests = new ProfileSettingRequests();
export default profileSettingRequests;
